module.exports = __webpack_public_path__ + "static/media/md-resize.dc9eb61d.svg";